import * as React from 'react';

import { cn } from '@shared/lib';

// TRAD-1962 — 그룹 리스트(설정형) 화면에서 섹션을 구분하는 라벨.
// MyPage.tsx 메뉴 카드(`rounded-xl border border-border bg-card divide-y divide-border`,
// 행 padding `px-4 py-3.5`)를 기준 화면으로 그 위에 얹는 섹션 라벨 — 새 레이아웃을 그리지 않고
// 기존 그룹 리스트 스캐폴드에 얹는 형태로 설계.
// 🔴 2026-09-01 정정 — 이 주석은 원래 "App.css의 `#root { text-align: center }`가 상속되므로 명시적으로
// 좌측정렬 재정의"였다. 그 전역 룰은 TRAD-2101에서 제거됐으므로 **더 이상 상속되지 않는다**
// (가드: src/__tests__/global-css-alignment.test.ts). 아래 className 의 좌측정렬 클래스는 현재 무효과이고,
// grouped-list 표준(iOS 기준)의 좌측정렬이라는 의도만 남는다. 제거는 동작 변경이라 잔재 정리 티켓 소관.
// 이 주석을 근거로 다른 화면에 우회용 좌측정렬 클래스를 새로 붙이지 말 것.
// (이 주석에는 그 클래스명을 리터럴로 적지 않는다 — 잔재 개수를 세는 grep 이 주석까지 세면
//  정리 티켓의 기준선이 오염된다. 2026-09-01 재감사에서 실제로 4건 부풀었다.)
const SettingSectionHeader = React.forwardRef<HTMLParagraphElement, React.HTMLAttributes<HTMLParagraphElement>>(
  ({ className, ...props }, ref) => (
    <p
      ref={ref}
      className={cn('px-4 pb-2 pt-4 text-xs font-medium text-muted-foreground', className)}
      {...props}
    />
  ),
);
SettingSectionHeader.displayName = 'SettingSectionHeader';

export { SettingSectionHeader };
